const SmartBonusActions = require("../../actions/metadata/SmartBonusActions.js");

const SmartBonusData = require("../../types/metadata/SmartBonus.js");

function getUpdatedSpec(originalState, specUpdate) {
    const newSpecData = Object.assign({}, SmartBonusData.GetSpecData(), specUpdate);

    const update = Object.assign({}, originalState.Metadata, {
        CurrentSpec: Object.assign({}, originalState.Metadata.CurrentSpec, {
            Data: newSpecData
        })
    });

    return Object.assign({}, originalState, {
        Metadata: update
    });
}

function getCurrentTargets(originalState) {
    return Object.assign({}, originalState.Metadata.CurrentSpec.Data.Targets);
}

const SmartBonusReducers = {
    [SmartBonusActions.TargetSelected](prev, action) {
        //const isComplete = action.Target && action.Target.GLCode.length > 0;
        //const arg = isComplete ? JSON.stringify({ StoreNumber: action.Target.GLCode }) : null;

        console.log("ACTION IS");
        console.log(action);

        const newSpecData = Object.assign({}, SmartBonusData.GetSpecData(), {
            Arg: JSON.stringify({ "month": action.month })
        });

        console.log("NEW SPEC DATA IS");
        console.log(newSpecData);

        const result = getUpdatedSpec(prev, newSpecData);

        return result;
    }
};

module.exports = SmartBonusReducers;


// WEBPACK FOOTER //
// ./src/reducers/metadata/SmartBonusReducers.js